import http from 'hub-http/clients/apiClient';
import ImportApi from '../import/api/Import';
import { makeSimpleQuickFetchWrapper } from '../utils/ajaxUtils';
const API_BASE = '/knowledge-content/v1/knowledge-articles/import';
const API_WARNING = `${API_BASE}/warning`;
export default class ImportArticlesApi {
  static getImportWarningsCount() {
    return http.get(`${API_WARNING}/count`);
  }
  static getAlteredArticlesDownloadLink() {
    return http.get(`${API_WARNING}/file`);
  }
  static reviewImportedArticle(articleId) {
    return http.put(`${API_WARNING}/${articleId}`);
  }
}
ImportArticlesApi.getImportedArticleNeedsReview = makeSimpleQuickFetchWrapper(articleId => `get-imported-article-needs-review-${articleId}`, articleId => http.get(`${API_WARNING}/${articleId}`));
ImportArticlesApi.getProgress = makeSimpleQuickFetchWrapper('get-import-articles-progress', ImportApi.getProgress);